'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

// TODO: Change this to building blocks to remove the necessity of declaring
// renderCta, renderPara, etc.

var renderImage = function renderImage(image) {
  if (image && image.src) {
    return _react2.default.createElement('img', { src: image.src, alt: image.alt, className: 'image-panel__image' });
  }
  return null;
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '3', className: 'image-panel__headline pp-sans-small-regular h4' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'image-panel__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};
/**
  Receives CTA and creates it according to the type.
  Underlying data structure shows the correct order
  semantically.
  TODO: Reuse this across Panels
*/
var renderCta = function renderCta(cta, properties) {
  if (cta && cta.text) {
    var targetValue = cta.target || '_self';
    return _react2.default.createElement(
      _button2.default,
      {
        id: cta.id,
        href: cta.href,
        className: 'image-panel__cta',
        fpti: '' + properties.name + properties.pnlIdx + '-' + cta.type + '-' + cta.text,
        color: cta.color || 'blue',
        target: targetValue
      },
      cta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: 'image-panel__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var ImagePanel = function ImagePanel(props) {
  var _props$content = props.content,
      image = _props$content.image,
      headline = _props$content.headline,
      paragraph = _props$content.paragraph,
      primaryCta = _props$content.primaryCta,
      secondaryCta = _props$content.secondaryCta,
      hatchText = _props$content.hatchText;


  var moleculeClasses = (0, _classnames2.default)('image-panel', props.className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    _react2.default.createElement(
      'div',
      { className: 'image-panel__top' },
      renderImage(image),
      renderHeadline(headline),
      renderParagraph(paragraph),
      !primaryCta && !secondaryCta && renderHatchText(hatchText)
    ),
    _react2.default.createElement(
      'div',
      { className: 'image-panel__bottom' },
      renderCta(primaryCta, props),
      renderCta(secondaryCta, props),
      (primaryCta || secondaryCta) && renderHatchText(hatchText)
    )
  );
};

exports.default = ImagePanel;


ImagePanel.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }), // isVisible
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }), // isVisible
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      type: _propTypes2.default.string,
      color: _propTypes2.default.oneOf(['blue', 'white']),
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    secondaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      type: _propTypes2.default.string,
      color: _propTypes2.default.oneOf(['outline-white', 'outline-blue']),
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

ImagePanel.defaultProps = {
  config: {
    type: 'ImagePanel'
  },
  content: {
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/ID/home/featuredoffer-ssense.png',
      alt: ''
    },
    headline: {
      text: '44 characters maximum'
    },
    paragraph: {
      text: '130 characters maximum for paragraph text which should ' + 'equal less than 4 lines of text, sentence case, normal punctuation.'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '18 characters maximum',
      type: 'PrmryCTA',
      color: 'white',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '18 characters maximum',
      type: 'ScndCTA',
      color: 'outline-white',
      target: '_self'
    },
    hatchText: {
      text: '44 characters maximum'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/image-panel/jsx/ImagePanel.js
// module id = 472
// module chunks = 4